import type { BackupPolicyType, Condition } from '@repo/api-gw-sdk';

import {
  isAzureEntraIdPolicyType,
  isNativePolicyType,
  isSaasWorkspacePolicyType,
} from './backupPoliciesTypes';

// The console names the sensitivity filter sensitivityLabels; the api-gateway rewrites it to
// sensitivityAnnotations on the way in. Matching the internal name here would hide the control for
// every sensitivity-filtered policy.
const CLASSIFICATION_FILTER_PROPERTIES = [
  'dataClasses',
  'dataClassEntities',
  'sensitivityLabels',
  'apps',
];

export const readsClassification = (condition?: Condition): boolean => {
  if (!condition) {
    return false;
  }
  if (
    condition.property &&
    CLASSIFICATION_FILTER_PROPERTIES.includes(condition.property)
  ) {
    return true;
  }
  return (condition.conditions ?? []).some(readsClassification);
};

// A classification scan never runs on these policies' resources, whatever they select: native backup
// hands the data to the provider's own vault, and SaaS tenants and Entra directories are not scanned
// at all. The server refuses a cadence for them, so offering one here would make the policy unsavable.
export const isScannablePolicyType = (policyType?: BackupPolicyType) =>
  !isSaasWorkspacePolicyType(policyType) &&
  !isAzureEntraIdPolicyType(policyType) &&
  !isNativePolicyType(policyType);

// A recurring classification schedule only earns its place when rescanning could move resources in
// or out of the policy, and only where those resources can be scanned at all.
export const showsClassificationCadence = (
  condition: Condition | undefined,
  policyType: BackupPolicyType | undefined
): boolean =>
  readsClassification(condition) && isScannablePolicyType(policyType);
